import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { apiUpdateGroupCEU, apiGetGroupCEU } from '../../../../api/ceu';
import { routes } from '../../../index';

import CEU from './CEU';

class Edit extends Component {
  state = {
    ceu: null,
    loaded: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedCEUId = match.params.id;

    apiGetGroupCEU(selectedCEUId).then((resp) => this.setState({ ceu: resp.data, loaded: true }));
  }

  render() {
    if (!this.state.loaded) return <noscript />;
    const { ceu } = this.state;

    return (
      <CEU
        ceu={ceu}
        submit={apiUpdateGroupCEU}
        finish={() => this.props.history.push(routes.ceus.group.root)}
        {...this.props}
      />
    );
  }
}

export default withRouter(Edit);
